import { CheckCircle, Star, Clock } from 'lucide-react';
import { IslamicSymbol } from '../ui/islamic-symbol';
import { Card, CardContent } from "../ui/card";
import { useLanguage } from '../../contexts/LanguageContext';

export function FeaturesSection() {
  const { t } = useLanguage();
  
  const features = [
    {
      icon: <IslamicSymbol size={32} className="w-8 h-8" />,
      title: t('features.noInterest.title'),
      description: t('features.noInterest.description')
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: t('features.transparent.title'),
      description: t('features.transparent.description')
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: t('features.quick.title'),
      description: t('features.quick.description')
    },
    {
      icon: <Star className="w-8 h-8" />,
      title: t('features.quality.title'),
      description: t('features.quality.description')
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('features.title')}
          </h2>
          <div className="w-24 h-1 bg-[#f91bdc] mx-auto rounded-full"></div>
        </div>

        <div className="mb-12">
          <Card className="border-[#f91bdc]/20 shadow-lg">
            <CardContent className="p-8">
              <p className="text-lg text-gray-700 leading-relaxed text-justify">
                {t('features.subtitle')}
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-[#f91bdc]/10 hover:border-[#f91bdc]/30">
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#f91bdc] text-white rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    {feature.icon}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}